module.exports = __webpack_public_path__ + "img/24.70b8429f.jpg";